import axios from "axios";
import { useCallback } from "react";
import { BASE_URL } from "../utils/constant";
import { getErrorsList, getHeaders } from "../utils/helper";
import { toast } from "react-toastify";

const useApi = () => {
  const AsyncGetApiCall = useCallback(async (endpoint, query) => {
    try {
      const url = BASE_URL + endpoint;
      console.log("url : ", url);

      const response = await axios.get(url, {
        params: query,
        headers: getHeaders(),
      });
      return response?.data;
    } catch (error) {
      if (error?.response?.data?.error === "SessionExpiredException") {
        toast.error(error?.response?.data?.message || "Session expired, Please login again.",
          { toastId: "session-expired-error" }
        );
        if (!endpoint.includes("/auth/logout")) {
          window.dispatchEvent(new CustomEvent("session-expired"));
        }
      }
      const errors = await getErrorsList(error?.response?.data?.message);
      return error?.response?.data || { errors };
    }
  }, []);

  const AsyncPutApiCall = useCallback(async (endpoint, data) => {
    try {
      const url = BASE_URL + endpoint;
      console.log("url is : ", url);

      const headers = getHeaders();
      if (data instanceof FormData) {
        delete headers["Content-Type"];
      }
      const response = await axios.put(url, data, { headers });
      return response?.data;
    } catch (error) {
      // if (error.response?.status === 401) {
      //   sessionStorage.clear();
      //   sessionStorage.clear();
      //   window.location.href = "/";
      // }
      const errors = await getErrorsList(error?.response?.data?.message);
      return error?.response?.data || { errors };
    }
  }, []);

  const AsyncPatchApiCall = useCallback(async (endpoint, data) => {
    try {
      const url = BASE_URL + endpoint;
      const headers = getHeaders();
      if (data instanceof FormData) {
        delete headers["Content-Type"];
      }
      const response = await axios.patch(url, data, { headers });
      return response?.data;
    } catch (error) {
      // if (error.response?.status === 401) {
      //   sessionStorage.clear();
      //   sessionStorage.clear();
      //   window.location.href = "/";
      // }
      const errors = await getErrorsList(error?.response?.data?.message);
      return error?.response?.data || { errors };
    }
  }, []);

  const AsyncPostApiCall = useCallback(async (endpoint, data) => {
    try {
      const url = BASE_URL + endpoint;
      console.log("url is : ", url);

      const headers = getHeaders();
      if (data instanceof FormData) {
        delete headers["Content-Type"];
      }
      const response = await axios.post(url, data, { headers });
      return response?.data;
    } catch (error) {
      // if (error.response?.status === 401) {
      //   sessionStorage.clear();
      //   sessionStorage.clear();
      //   window.location.href = "/";
      // }
      const errors = await getErrorsList(error?.response?.data?.message);
      return error?.response?.data || { errors };
    }
  }, []);

  const AsyncDeleteApiCall = useCallback(async (endpoint, data) => {
    try {
      const url = BASE_URL + endpoint;
      console.log("url is : ", url);

      const response = await axios.delete(url, {
        data,
        headers: getHeaders(),
      });
      return response?.data;
    } catch (error) {
      // if (error.response?.status === 401) {
      //   sessionStorage.clear();
      //   sessionStorage.clear();
      //   window.location.href = "/";
      // }
      const errors = await getErrorsList(error?.response?.data?.message);
      return error?.response?.data || { errors };
    }
  }, []);

  return {
    AsyncGetApiCall,
    AsyncPatchApiCall,
    AsyncPutApiCall,
    AsyncPostApiCall,
    AsyncDeleteApiCall,
  };
};

export default useApi;
